module.exports = __webpack_public_path__ + "static/media/image.43f6630f.jpg";